export default [
  {
    title: '周一',
    key: 'mon',
    align: 'center'
  },
  {
    title: '周二',
    key: 'tue',
    align: 'center'
  },
  {
    title: '周三',
    key: 'wed',
    align: 'center'
  },
  {
    title: '周四',
    key: 'thur',
    align: 'center'
  },
  {
    title: '周五',
    key: 'fri',
    align: 'center'
  },
  {
    title: '周六',
    key: 'sat',
    align: 'center'
  },
  {
    title: '周日',
    key: 'sun',
    align: 'center'
  }
]
